import React, { Fragment, useContext, useEffect, useState } from "react";
import { Card,Button } from "react-bootstrap";
import Dropdown from "components/Fields/Dropdown";
import InputField from "components/Fields/InputField";
import { Col, Row } from "react-bootstrap";
import Item from "./Item";
import NoItemsFound from "./NoItemsFound";
import AxiosContext from "store/axios-context";
import { useHistory } from "react-router";
import "./Quote.css";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import helpers from "../../store/helpers";

export default function Details({
  data,
  customers,
  destinations,
  shipmentTerms,
  currencies,
  items
}) {
  const history = useHistory();
  const axiosCtx = useContext(AxiosContext);
  const [editId, setEditId] = useState(null);
  const [formError, setFormError] = useState(null);
  const [customer, setCustomer] = useState(data.cust_id);
  const [fromDestination, setFromDestination] = useState(data.from_id);
  const [toDestination, setToDestination] = useState(data.to_id);
  const [pieces, setPieces] = useState(data.pieces);
  const [actualWeight, setActualWeight] = useState(data.act_wt);
  const [chargeableWeight, setChargeableWeight] = useState(data.charge_wt);
  const [volume, setVolume] = useState(data.volume);
  const [shipmentTerm, setShipmentTerm] = useState(data.shipment_id);
  const [currency, setCurrency] = useState(data.currency);
  const [hideTotal, setHideTotal] = useState(data.hide_total === "1");
  const [description, setDescription] = useState(data.description);

  // const [items, setItems] = useState(data.items);
  
   const [chargeDescriptions, setChargeDescriptions] = useState([]);
   const [costTypes, setCostTypes] = useState([]);
     const [parties, setParties] = useState([]);
    
  const [total, setTotal] = useState({
    cost: 0,
    margin: 0,
    sum: 0,
    profit: 0,
  });
  const [validItems, setValidItems] = useState(true);
  useEffect(() => {
    data.id && setEditId(data.id);
    data.customer && setCustomer(data.customer);
    data.currency && setCurrency(data.currency);
    data.from && setFromDestination(data.from);
    data.to && setToDestination(data.to);
    data.shipement && setShipmentTerm(data.shipement);
    data.pieces && setPieces(data.pieces);
    data.act_wt && setActualWeight(data.act_wt);
    data.charge_wt && setChargeableWeight(data.charge_wt);
    data.volume && setVolume(data.volume);
    data.description && setDescription(data.description);
    data.hide_total && setHideTotal(data.hide_total === "1");
    // data.items && setItems(data.items);
    getChargeDescriptions();
    getCostTypes();
    getParties();
  }, [data]);
  useEffect(() => {
    // let temp = { cost: 0, margin: 0, sum: 0, profit: 0 };
    // items.forEach((item) => {
    //   let cost = parseFloat(item.cost);
    //   if (!isNaN(cost)) {
    //     temp.cost += helpers.getIntVal(cost);
    //   }
    //   let sum = parseFloat(item.total);
    //   if (!isNaN(sum)) {
    //     temp.sum += helpers.getIntVal(sum);
    //   }
    //   let profit = parseFloat(item.profit);
    //   if (!isNaN(profit)) {
    //     temp.profit += helpers.getIntVal(profit);
    //   }
    // });
    // if (temp.cost > 0) {
    //   temp.margin = helpers.getIntVal((temp.profit / temp.cost) * 100);
    // }
    // setTotal(temp);

    if (items && items.length > 0) {
      
      setItemFields(items.map(item => ({    
        id: item.id || Date.now(), // Ensure each item has an ID
        chargeDescription: chargeDescriptions.find(desc => desc.id === item.name) || null, // Find matching dropdown option
        supplier: parties.find(party => party.id === item.supplier) || null, // Find supplier
        costType: costTypes.find(cost => cost.id === item.costType) || null, 
        costUnit: item.qty || "",
        costCurrency: currencies.find(currency => currency.id === item.cost_currency) || null, 
        costAmount: item.cost || "",
        costTotal: item.total || "",  
        costVat: item.costVat || "",
        revenueCurrency:currencies.find(currency => currency.id === item.revenue_currency) || null, 
        revenueAmount: item.revenue_amount || "",
        revenueVat: item.revenue_vat || "",
        revenueTotal: item.revenue_total || ""
      })));
    }
  }, [items,chargeDescriptions, parties, currencies,costTypes]);

  const validateItems = () => {
    let isValid = true;
    const tmp = [...items].map((item) => {
      const errors = {};
      if (item.charges_description === "" || item.charges_description === null || item.charges_description === undefined) {
        errors.name = ["The charge description field is required."];
        isValid = false;
      }
      if (
        item.cost === "" ||
        item.cost === null ||
        parseFloat(item.cost) <= 0
      ) {
        isValid = false;
        errors.cost = ["The cost field is required."];
      }
      item.errors = errors;
      return item;
    });

    // setItems(tmp);
    setValidItems(isValid);
    return isValid;
  };

  const addNewItem = () => {
    if (!validateItems()) {
      return;
    }
    const tmp = [...items];
    tmp.push({
      charges_description: "",
      cost: 0,
      margin: 0,
      total: 0,
      profit: 0,
      comment: "",
    });
    // setItems(tmp);
  };
  const removeItem = (index) => {
    const tmp = [...items];
    tmp.splice(index, 1);
    // setItems(tmp);
  };
  const setValues = (index, values) => {
    const tmp = [...items];
    tmp[index] = values;
    // setItems(tmp);
    validateItems();
  };
 const [itemFields, setItemFields] = useState([
     {
       id: Date.now(),
       chargeDescription: "",
       costType: "",
      supplier: "",
      costUnit: "",
      costCurrency: "",
      costAmount: "",
      costVat: "",
      costTotal: "",
      revenueCurrency: "",
      revenueAmount: "",
      revenueVat: "",
      revenueTotal: ""
     },
   ]);
   const handleItemFieldChange = (index, field, value) => {
    setItemFields(prevFields => {
      const updatedFields = [...prevFields];
      updatedFields[index] = { ...updatedFields[index], [field]: value };

      // Convert values to numbers (default to 0 if empty)
      const costAmount = parseFloat(updatedFields[index].costAmount) || 0;
      const costTotal = parseFloat(updatedFields[index].costTotal) || 0;
      const costVat = parseFloat(updatedFields[index].costVat) || 0;
      const costUnit = parseFloat(updatedFields[index].costUnit) || 1; // Default unit to 1 if empty
      const revenueAmount = parseFloat(updatedFields[index].revenueAmount) || 0;
      const revenueVat = parseFloat(updatedFields[index].revenueVat) || 0;
      const revenueUnit = parseFloat(updatedFields[index].costUnit) || 1; // Default unit to 1 if empty

      // Calculate total including unit multiplication
      // updatedFields[index].costTotal = (costAmount * costUnit) + ((costAmount * costUnit) * (costVat / 100));
      // updatedFields[index].costTotal = costTotal;
      updatedFields[index].costTotal = (costAmount) + ((costAmount) * (costVat / 100));
      updatedFields[index].revenueTotal = (revenueAmount * revenueUnit) + ((revenueAmount * revenueUnit) * (revenueVat / 100));

      return updatedFields;
    });
};

  const addItemField = () => {
    setItemFields([
      ...itemFields,
      {
        id: Date.now(),
        chargeDescription: "",
        costType: "",
        supplier: "",
        costUnit: "",
        costCurrency: "",
        costAmount: "",
        costVat: "",
        costTotal: "",
        revenueCurrency: "",
        revenueAmount: "",
        revenueVat: "",
        revenueTotal: ""
      },
    ]);
  };

  const removeItemField = (id) => {
    setItemFields(itemFields.filter((field) => field.id !== id));
  };
  const getCostTypes = () => {
    axiosCtx.instance.get(`cost-type`)
      .then((response) => {
        setCostTypes(response.data.data);
      })
      .catch((error) => {
        // setFormError(error.response.data);
        // setLoading(false);
      });
  };
  const getChargeDescriptions = () => {
    axiosCtx.instance.get(`cost-description`)
      .then((response) => {
        setChargeDescriptions(response.data.data);
        // console.log(response.data.data);
      })
      .catch((error) => {
        // setFormError(error.response.data);
        // setLoading(false);
      });
  };
  const getParties = () => {
    axiosCtx.instance.get(`party`)
      .then((response) => {
        setParties(response.data.data);
      })
      .catch((error) => {
      });
  };
  const getQuoteValues = () => {
    return {
      cust_id: customer ? customer.id : null,
      from_id: fromDestination ? fromDestination.id : null,
      to_id: toDestination.id,
      pieces: pieces,
      act_wt: actualWeight,
      charge_wt: chargeableWeight,
      volume: volume,
      shipment_id: shipmentTerm ? shipmentTerm.id : null,
      currency: currency ? currency.id : null,
      description: description,
      hide_total: hideTotal === true,
      items: itemFields,
    };
  };

  const saveQuote = (e) => {
    e.preventDefault();
    const data = getQuoteValues();
    let url = "/store-quotations";
    if (editId) {
      data.id = editId;
      url = "/update-quotation";
    }
    axiosCtx.instance
      .post(url, data)
      .then((response) => {
        history.push({
          pathname: `/quotations`,
          state: {},
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 422) {
          setFormError(error.response.data);
        } else {
          error.response.message
            ? alert(error.response.message)
            : alert("Something went wrong1 !");
        }
      });
  };
  const saveAsNewQuote = (e) => {
    e.preventDefault();
    const data = getQuoteValues();
    axiosCtx.instance
      .post("store-quotation", data)
      .then((response) => {
        history.push({
          pathname: `/quotations`,
          state: {},
        });
      })
      .catch((error) => {
        if (error.response.status === 422) {
          setFormError(error.response.data);
        } else {
          error.response.message
            ? alert(error.response.message)
            : alert("Something went wrong2 !");
        }
      });
  };

  return (
    <Fragment>
      <Card className="p-4">
        <h4 className="m-0 mb-2">Create Quotation</h4>
        <Row className="justify-content-between">
          <Col md="5" className="my-3">
            <Dropdown
              id="cust_id"
              placeholder="Customer"
              label="name"
              value={customer}
              options={customers}
              onChange={(event, newValue) => setCustomer(newValue)}
              formError={
                formError && formError.errors.cust_id
                  ? formError.errors.cust_id
                  : ""
              }
            />
          </Col>
          <Col md="4" className="my-3">
            <Dropdown
              id="currency"
              placeholder="Currency"
              label="currency_label"
              value={currency}
              options={currencies}
              onChange={(event, newValue) => setCurrency(newValue)}
              formError={
                formError && formError.errors.currency
                  ? formError.errors.currency
                  : ""
              }
            />
          </Col>
        </Row>
        {customer && (
          <Row>
            <Col md="12" className="ml-3 my-1" style={{ fontWeight: 600 }}>
              {customer.address_1}
              {customer.address_1 && <br />}
              {customer.address_2}
              {customer.address_2 && <br />}
              {customer.city}
              {customer.city && <br />}
              {customer.country}
              {customer.country && <br />}
              {customer.zip_code}
              {customer.zip_code && <br />}
            </Col>
          </Row>
        )}
        <Row>
          <Col md="6" className="my-3">
            <Dropdown
              id="from_id"
              placeholder="From"
              label="code"
              label1="name"
              value={fromDestination}
              options={destinations}
              onChange={(event, newValue) => setFromDestination(newValue)}
              formError={
                formError && formError.errors.from_id
                  ? formError.errors.from_id
                  : ""
              }
            />
          </Col>
          <Col md="6" className="my-3">
            <Dropdown
              id="to_id"
              placeholder="To"
              label="code"
              label1="name"
              value={toDestination}
              options={destinations}
              onChange={(event, newValue) => setToDestination(newValue)}
              formError={
                formError && formError.errors.to_id
                  ? formError.errors.to_id
                  : ""
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md="3" className="my-3 form-group">
            <InputField
              id="pieces"
              placeholder="Pieces"
              label="Pieces"
              value={pieces}
              onChange={(event) => setPieces(event.target.value)}
              formError={
                formError && formError.errors.pieces
                  ? formError.errors.pieces
                  : ""
              }
            />
          </Col>
          <Col md="3" className="my-3 form-group d-flex">
            <InputField
              id="act_wt"
              placeholder="Actual Weight"
              label="Actual Weight"
              value={actualWeight}
              onChange={(event) => setActualWeight(event.target.value)}
              formError={
                formError && formError.errors.act_wt
                  ? formError.errors.act_wt
                  : ""
              }
            />
            <button
              className="btn btn-simple flex-shrink-0 my-0"
              style={{ height: "2.8em" }}
              disabled
            >
              KG
            </button>
          </Col>
          <Col md="3" className="my-3 form-group d-flex">
            <InputField
              id="charge_wt"
              placeholder="Chargeable Weight"
              label="Chargeable Weight"
              value={chargeableWeight}
              onChange={(event) => setChargeableWeight(event.target.value)}
              formError={
                formError && formError.errors.charge_wt
                  ? formError.errors.charge_wt
                  : ""
              }
            />
            <button
              className="btn btn-simple flex-shrink-0 my-0"
              style={{ height: "2.8em" }}
              disabled
            >
              KG
            </button>
          </Col>
          <Col md="3" className="my-3 form-group">
            <InputField
              id="volume"
              placeholder="Volume"
              label="Volume"
              value={volume}
              onChange={(event) => setVolume(event.target.value)}
              formError={
                formError && formError.errors.volume
                  ? formError.errors.volume
                  : ""
              }
            />
          </Col>
          <Col md="6" className="my-3">
            <Dropdown
              id="shipment_id"
              placeholder="Shipment Term"
              label="title"
              value={shipmentTerm}
              options={shipmentTerms}
              onChange={(event, newValue) => setShipmentTerm(newValue)}
              formError={
                formError && formError.errors.shipment_id
                  ? formError.errors.shipment_id
                  : ""
              }
            />
          </Col>
          <Col md="6" className="my-3 form-group">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hideTotal}
                    onChange={(e) => setHideTotal(e.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Hide Total"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="6" className="my-3 form-group">
            <InputField
              id="description"
              placeholder="Description"
              label="Description"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              multiline={true}
              rows={4}
              formError={
                formError && formError.errors.description
                  ? formError.errors.description
                  : ""
              }
            />
          </Col>
        </Row>

        <h4 className="m-0">Items</h4>
        <div className="overflow-scroll">
        {itemFields.map((field, index) => (
      <div key={field.id} className="border p-3 mb-3">
        <div className="form-row align-items-center">
          <div className="col-3">
            <Dropdown id={`chargeDescriptions-${index}`} placeholder="Charge Description" label="name" options={chargeDescriptions} value={field.chargeDescription} onChange={(e, newValue) => handleItemFieldChange(index, "chargeDescription", newValue)} />
          </div>
        
        <div className="col-2">
                   <Dropdown id={`costTypes-${index}`} placeholder="Cost Type" label="name" options={costTypes} value={field.costType} onChange={(e, newValue) => handleItemFieldChange(index, "costType", newValue)} />
                 </div>
                 <div className="col-2">
                   <Dropdown id={`parties-${index}`} placeholder="Supplier" label="name" options={parties} value={field.supplier} onChange={(e, newValue) => handleItemFieldChange(index, "supplier", newValue)} />
                 </div>
                 <div className="col-2">
                   <InputField id={`costUnit-${index}`} type="number" placeholder="Unit" label="Unit" value={field.costUnit} onChange={(e) => handleItemFieldChange(index, "costUnit", e.target.value)} />
                 </div>
                 <div className="col-2 text-right">
                   <Button variant="danger" onClick={() => removeItemField(field.id)}>Remove</Button>
                 </div>
               </div>
       
               <div className="form-row py-3 align-items-center font-weight-bold mb-4 mt-2 bg-lite-blue">
                 <div className="col-6"><span className="ml-3">COST</span></div>
                 <div className="col-6"><span className="ml-4">REVENUE</span></div>
               </div>
       
               <div className="form-row align-items-center mt-2">
                 <div className="col-6">
                   <div className="form-row align-items-center mr-3">
                     <div className="col-7 d-flex form-group">
                       <Dropdown id={`currencies-cost-${index}`} placeholder="Currency" label="currency_label" options={currencies} value={field.costCurrency} onChange={(event, newValue) => handleItemFieldChange(index, "costCurrency", newValue)} />
                       <InputField id={`cost-amount-${index}`} type="number" placeholder="Amount" label="Amount" value={field.costAmount} onChange={(e) => handleItemFieldChange(index, "costAmount", e.target.value)} />
                     </div>
                     <div className="col-2 form-group">
                       <InputField id={`cost-vat-${index}`} type="number" placeholder="VAT%" label="VAT%" value={field.costVat} onChange={(e) => handleItemFieldChange(index, "costVat", e.target.value)} />
                     </div>
                     <div className="col-3 form-group">
                       <InputField id={`cost-total-${index}`} type="number" placeholder="Total" label="Total" value={field.costTotal} onChange={(e) => handleItemFieldChange(index, "costTotal", e.target.value)}  />
                     </div>
                   </div>
                 </div>
                 <div className="col-6">
                   <div className="form-row align-items-center ml-3">
                     <div className="col-7 d-flex form-group">
                       <Dropdown id={`currencies-revenue-${index}`} placeholder="Currency" label="currency_label" options={currencies} value={field.revenueCurrency} onChange={(event, newValue) => handleItemFieldChange(index, "revenueCurrency", newValue)} />
                       <InputField id={`revenue-amount-${index}`} type="number" placeholder="Amount" label="Amount" value={field.revenueAmount} onChange={(e) => handleItemFieldChange(index, "revenueAmount", e.target.value)} />
                     </div>
                     <div className="col-2 form-group">
                       <InputField id={`revenue-vat-${index}`} type="number" placeholder="VAT%" label="VAT%" value={field.revenueVat} onChange={(e) => handleItemFieldChange(index, "revenueVat", e.target.value)} />
                     </div>
                     <div className="col-3 form-group">
                       <InputField id={`revenue-total-${index}`} type="number" placeholder="Total" label="Total" value={field.revenueTotal} />
                     </div>
                   </div>
                 </div>
               </div>
       
             </div>
           ))}
  {formError &&
                    formError.errors &&
                    formError.errors.cost_currency_id && (
                      <p className="text-danger small pt-2">
                        {formError.errors.costCurrency.join('. ')}
                      </p>
                    )}
                  {formError &&
                    formError.errors &&
                    formError.errors.cost_amount && (
                      <p className="text-danger small pt-2">
                        {formError.errors.costAmount.join('. ')}
                      </p>
                    )}
                  {formError &&
                    formError.errors &&
                    formError.errors.cost_vat && (
                      <p className="text-danger small pt-2">
                        {formError.errors.costVat.join('. ')}
                      </p>
                    )}

                  {formError &&
                    formError.errors &&
                    formError.errors.have_invoice && (
                      <p className="text-danger pt-2">
                        {formError.errors.have_invoice}
                      </p>
                    )}

                  {formError &&
                    formError.errors &&
                    formError.errors.no_airwaybill && (
                      <p className="text-danger pt-2">
                        {formError.errors.no_airwaybill}
                      </p>
                    )}
    <Button variant="success" onClick={addItemField} className="mt-3">+ Add More Item</Button>
        </div>
        <div className="border-top mt-4 d-flex">
          {/* {!validItems && (
            <div className="text-danger mt-4">
              Please solve validation issues
            </div>
          )} */}
          <div className="text-right" style={{ marginLeft: "auto" }}>
            {editId && (
              <button onClick={saveAsNewQuote} className="btn btn-primary mt-4">
                Save As New
              </button>
            )}
            <button onClick={saveQuote} className="btn btn-primary mt-4">
              Save
            </button>
          </div>
        </div>
      </Card>
    </Fragment>
  );
}
   